export const EXTERNAL_LINKS = {
  notionLumaArticle: 'https://weavyai.notion.site/Luma-Dream-Machine-on-Weavy-10b355cab8da8071a82fd1e8db4c5045?pvs=25',
  discordInvite: 'https://discord.gg/jB6vn2ewxW',
  designAppTutorial: 'https://www.youtube.com/watch?v=D3GJ81-YnvQ',
  importModelTutorial: 'https://www.youtube.com/watch?v=tBIjC5BUGg0',
  termsOfService: 'https://content.weavy.ai/terms-of-service',
  privacyPolicy: 'https://content.weavy.ai/privacy-policy',
  browserConfiguration: 'https://help.weavy.ai/en/articles/12449982-how-do-i-configure-my-browser-for-weavy',
};
